import { render, staticRenderFns } from "./ProofSkipReview.vue?vue&type=template&id=56881f43"
import script from "./ProofSkipReview.vue?vue&type=script&lang=js"
export * from "./ProofSkipReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports